import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import Search from "../header/Search"

import { Tag } from "rsuite"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import {  Spin, Tabs } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../../utils/storage.service";
import PopupViewServices from "../PopupViewServices"
import ViewDetailSaleTvvCtmByDay from "./ViewDetailSaleTvvCtmByDay"
import ViewDetailOrderSaleTvvCtm from "./ViewDetailOrderSaleTvvCtm"
import ViewOrderNoTvv from "../ktv/ViewOrderNoTvv"

import styles from "../style.module.css"
import "../scss/report.scss"

const queryParams = new URLSearchParams(window.location.search)

const ReportSaleTvCtm = () => {
    const [title, setTitle] = useState("Chi tiết Sale")
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isView, setIsView] = useState(false);
    const [totalComKtv, setTotalComKtv] = useState(0);
    const [dataViewService, setDataViewService] = useState([])
    const [chart, setChart] = useState([])
    const [table, setTable] = useState([])
    const [tableByDay, setTableByDay] = useState([])
    const [keyword, setKeyword] = useState([])
    const [totalComTvv, setTotalComTvv] = useState(0)
    const [com, setCom] = useState(0)
    const [comNoTax, setComNoTax] = useState(0)
    const [countOrderNew, setCountOrderNew] = useState(0)
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [token, setToken] = useState('')
    const [userId, setUserId] = useState(userAdmin.id)
    const [userName, setUserName] = useState(userAdmin.name)
    const [orderNo, setOrderNo] = useState([])
    const [aov, setAov] = useState(0)
    const [totalPaidNoTax, setTotalPaidNoTax] = useState(0)

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }


    const handleUser = (x) => {
        setUserId(x.value)
        setUserName(x.label)
    }

    const fetchData = async (sD, eD, s) => {
        const res = await axiosService(`api/sale/online/report-sale-online-tv-new/all?type=1&user_id=${userId}&user_name=${userName}&start=${sD}&end=${eD}&keyword=${keyword}&role=${userAdmin.role}`, "GET")
        if (res.data.code === 200) {
            setLoading(false)
            const {totalPaid, totalPaidNoTax, totalNewOrder, com, comNoTax, dataTable, dataTableByDay, orderNo, countSaleTvv, countKtvTv} = res.data.data
            setTotalComTvv(totalPaid)
            setTotalPaidNoTax(totalPaidNoTax)
            setCountOrderNew(totalNewOrder)
            setCom(com)
            setComNoTax(comNoTax)
            setTable(dataTable)
            setTableByDay(dataTableByDay)
            setOrderNo(orderNo)
        }
    }

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, keyword, userId])

    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const showPopupViewService = (e) => {
        setIsView(!isView)
        setDataViewService(e)
        let totalCom = 0
        for (let item of e) {
            totalCom += item.total
        }
        setTotalComKtv(totalCom)
    }

    const handleIsView = (e) => {
        setIsView(!isView)
    }
   
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }

    const itemsTabs = [
        {
            key: "1",
            label: "Chi tiết đơn tư vấn",
            children: (
                <ViewDetailOrderSaleTvvCtm
                    table={table}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: "2",
            label: "Thực thu tư vấn theo ngày",
            children: (
                <ViewDetailSaleTvvCtmByDay
                    table={tableByDay}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
        {
            key: "3",
            label: "Đơn khách còn nợ",
            children: (
                <ViewOrderNoTvv
                    table={orderNo}
                    startDate={startDate}
                    endDate={endDate}
                    userId={userId}
                    userName={userName}
                />
            ),
        },
    ]
    return (
        <>
            <div className={`container-fluid ${styles.background}`}>
                <Search startDate={startDate} endDate={endDate}
                    handleRangeDate={handleRangeDate} store={store}
                    handleStore={handleStore}
                    handleUser={handleUser}
                    title={title} type={"sales"}
                    csvData={table} isExport={isExport}
                    handleExportData={handleExportData}
                    onChangeKeyword={onChangeKeyword}
                    header={
                        [
                            { label: 'Nhân viên', key: "name" },
                            { label: 'Ngày thanh toán', key: "date" },
                            { label: "Hoá đơn", key: "order_code" },
                            { label: "Mã giao dịch", key: "transaction_code" },
                            { label: "Tên khách hàng", key: `customer_name` },
                            { label: "Số điện thoại", key: `customer_mobile` },
                            { label: "Sản phẩm", key: `product_name` },
                            { label: "Thực thu", key: `paid` },
                            { label: "Cơ sở", key: `store_name` },
                        ]
                    }
                    userAdmin={userAdmin}
                />
                <Spin spinning={loading} tip="Đang tải...">
                    <Row>
                        <Col xs={12} xl={8}>
                            <Row className="h-100">

                                <Col xs={6} md={3} className="mb-2">
                                    <Tag color="blue" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tổng tiền đã thu: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>{convertCurrency(totalComTvv)}</span>
                                            </div>
                                        </div>
                                        <span className={styles.textTag3}>Tổng thực thu bán hàng: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>
                                                    {convertCurrency(totalPaidNoTax)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={6} md={3} className="mb-2">
                                    <Tag color="violet" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tổng số đơn mới: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                                <br />
                                                <br />
                
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>{countOrderNew}</span>
                                                <br />

                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                                <Col xs={6} md={3} className="mb-2">
                                    <Tag color="green" className="w-100 p-2 h-100">
                                        <span className={styles.textTag3}>Tổng hoa hồng tư vấn: </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>
                                                {convertCurrency(com)}</span>
                                            </div>
                                        </div>
                                        <span className={styles.textTag3}>Tổng hoa hồng trước thuế </span>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <span className={styles.textTag}> </span>
                                            </div>
                                            <div className="ml-3">
                                                <span className={styles.textTag}>
                                                {convertCurrency(comNoTax)}</span>
                                            </div>
                                        </div>
                                    </Tag>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Tabs defaultActiveKey="1" items={itemsTabs} />
                        </Col>
                    </Row>
                </Spin>
            </div>
            {isView ?
               <>
                <PopupViewServices
                    show={isView}
                    close={handleIsView}
                    dataViewService={dataViewService}
                    totalComKtv={totalComKtv}
                >
                </PopupViewServices>
                </>
            : null}
        </>
    )
}
export default ReportSaleTvCtm